import React, { useContext, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import TextMediaBanner from '../../components/PageComponent/textMediaBanner';
import UpdateController from '../../components/UpdateController';
import { LocalizationContext } from '../../contexts';
import './index.scss';

export default function BannerEditor({ data, disciplinesList, ageGradesList, sectorsList, update, deleteBanner }) {
    const history = useHistory();
    const textMediaBannerValidator = useRef(null);
    const [localization] = useContext(LocalizationContext);
    const pagesList = useRef(['books', 'courses', 'recommendations', 'catalog'].map(pId => {return {id: pId,  text: localization.labels.pages[pId]}}));
    const [hasChanges, setHasChanges] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [pages, _setPages] = useState([]);
    const setPages = (newPages) => {
        setHasChanges(true);
        _setPages(newPages);
    };
    const [bannerData, _setBannerData] = useState({});
    const setBannerData = (newBannerData) => {
        setHasChanges(true);
        _setBannerData({ ...bannerData, ...newBannerData });
    };

    useEffect(() => {
        const bannerData = {items: [{...data.content, isPublish: data.isPublish, ageGrades: data.ageGrades, disciplines: data.disciplines, sectors: data.sectors }]};
        _setBannerData(bannerData);
        _setPages(data.pages ? data.pages.map(i => pagesList.current.find(d => d.id === i)) : []);
    }, [data]);

    const formatDate = (inputDate) => {
        let date = '';
        if (inputDate) {
            date = new Date(inputDate);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            let day = date.getDate();
            let hours = date.getHours();
            let minutes = date.getMinutes();
            minutes = minutes < 10 ? '0' + minutes : minutes;
            date = day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
        }
        return date;
    }

    const updateItem = () => {
        let content = {...bannerData.items[0]};
        let isPublish = content.isPublish;
        let ageGrades = content.ageGrades;
        let disciplines = content.disciplines;
        let sectors = content.sectors;
        delete content.isPublish;
        delete content.ageGrades;
        delete content.disciplines;
        delete content.sectors;
        const newData = {
            ...data,
            content: content,
            isPublish: isPublish,
            ageGrades: ageGrades,
            disciplines: disciplines,
            sectors: sectors,
            pages: pages.map(p => p.id)
        };

        const promise = update(newData).then(() => {
            setHasChanges(false);
        });
        return promise;
    };

    const backToGrid = () => {
        history.push('/internalPages');
    };

    const topTools = <div className="app-banners_management-editor-update_controller-top_tools">
        <Button className="update_controller-update_btn" onClick={backToGrid}>{localization.labels.bannersManagement.editor.back_to_item_list}</Button>
        {!!data.id && <Button className="update_controller-update_btn" onClick={() => {setShowDeleteDialog(true);}}>{localization.labels.bannersManagement.editor.delete_item}</Button>}
    </div>;

    return <div className="app-banners_management-editor">
        <UpdateController lastEditor={data.lastUpdatedUser} lastUpdate={formatDate(data.lastUpdatedDate)} hasChanges={hasChanges} update={updateItem} topTools={topTools}>
            <div className="app-banners_management-editor-textMedia">
                <div className="form-field form-field--outside">
                    <label className="form-field__label">{localization.labels.bannersManagement.editor.add_pages}</label>
                    <MultiSelect 
                        dir={localization.labels.dir}
                        data={pagesList.current}
                        value={pages}
                        onChange={({ value }) => {
                            setPages(value);
                        }}
                        textField="text"
                        dataItemKey="id"
                    />
                </div>
                <TextMediaBanner 
                    data={bannerData} 
                    validator={textMediaBannerValidator} 
                    ageGradesList={ageGradesList}
                    disciplinesList={disciplinesList}
                    sectorsList={sectorsList}
                    settingsData={{
                        title: ' ',
                        maxSize: 1,
                        minSize: 1,
                        type: 'personal',
                        setBackgroundColor: true,
                    }}
                    onUpdate={(newData)=>{
                        setBannerData(newData);
                    }}
                />
            </div>
        </UpdateController>
        {showDeleteDialog && <Dialog onClose={() => {setShowDeleteDialog(false);}} title={false} >
            <p>{localization.labels.bannersManagement.editor.delete_message}</p>
            <DialogActionsBar>
                <button className="k-button k-primary" onClick={() => {setShowDeleteDialog(false); deleteBanner();}}>{localization.labels.bannersManagement.editor.delete}</button>
                <button className="k-button" onClick={() => {setShowDeleteDialog(false);}}>{localization.labels.bannersManagement.editor.cancel_delete}</button>
            </DialogActionsBar>
        </Dialog>}
    </div>;
}